import React, { useContext, useMemo, useRef } from "react";
import Editor from "components/Editor";
import styles from "./index.module.scss";
import className from "classnames";
import { Button, Checkbox, Input, message, Modal, Spin } from "antd";
import Space from "components/Space";
import useRequestFn from "utils/useRequestFn";
import { DiscussContent } from "../../context";
import Form from "rc-field-form";
import { AnswerFormData, editPost, postAnswer } from "service/discuss";
import { errorMessage, isTrue } from "service/service";
import { isEditorTextEmpty } from "utils/common";
import lodash, { isNull } from "lodash-es";
import BraftEditor from "braft-editor";

export default function AnswerEditor() {
    const editorRef = useRef<BraftEditor>(null);

    const {
        uuid,
        topicType,
        setIsWriting,
        updateDiscussDetail,
        discussDetail,
        editUuid,
        setEditUuid
    } = useContext(DiscussContent);

    // 查找自己的回答
    const myAnswer = useMemo(() => {
        if (editUuid) {
            const answer = lodash.find(discussDetail?.replies, {
                uuid: editUuid
            });
            if (answer) {
                editorRef?.current?.setValue(
                    BraftEditor.createEditorState(answer.replyContent)
                );
                return {
                    ...answer,
                    anonymousSpeak: isTrue(answer.anonymousSpeak)
                };
            }
        }
    }, [discussDetail, editUuid]);

    console.log(editUuid);

    const [onSave, { loading }] = useRequestFn(async (data: AnswerFormData) => {
        if (isEditorTextEmpty(data.replyContent)) {
            message.warn("内容不能为空!");
            return;
        }

        try {
            if (myAnswer) await editPost(uuid, myAnswer.uuid, data);
            else await postAnswer(uuid, data);
            setIsWriting(false);
            setEditUuid(null);
            updateDiscussDetail();
        } catch (e) {
            Modal.error({ content: errorMessage(e) });
        }
    });

    function onCancel() {
        setEditUuid(null);
        setIsWriting(false);
    }

    return (
        <Form
            onFinish={onSave}
            className={className(styles.root, "container")}
            initialValues={myAnswer || {}}
            preserve={false}>
            <Spin spinning={loading}>
                {!myAnswer && (
                    <Form.Field name="topicType" initialValue={topicType}>
                        <Input hidden />
                    </Form.Field>
                )}
                <Form.Field name="replyContent" valuePropName="data">
                    <Editor data="" ref={editorRef} />
                </Form.Field>
                <Space className={styles.bottom}>
                    {isTrue(discussDetail?.canAnonymousSpeak) && (
                        <Form.Field
                            name="anonymousSpeak"
                            valuePropName="checked">
                            <Checkbox disabled={!isNull(editUuid)}>
                                匿名发言
                            </Checkbox>
                        </Form.Field>
                    )}

                    <Button onClick={onCancel}>取消编辑</Button>

                    <Button type="primary" htmlType="submit">
                        {!!myAnswer ? "修改发言" : "提交发言"}
                    </Button>
                </Space>
            </Spin>
        </Form>
    );
}
